import styled, { css } from 'styled-components';
import {
  ArrowForward,
  CheckCircle,
  CheckCircleOutlineUnchecked
} from '@carvana/icons';
import { navSectionStyles } from '../../navigation-rail.styles';

export const NavTab = styled.div`
  ${navSectionStyles}
  cursor: pointer;
  height: 86px;

  &.disabled {
    color: ${props => props.theme.carvana.gray.light};
    cursor: not-allowed;
  }

  &.active {
    background-color: ${props => props.theme.carvana.gray.background};
  }
`;

const common = {
  navIconSize: {
    height: '18px',
    width: '18px'
  },
  navTabText: css`
    ${NavTab}.disabled & {
      color: ${props => props.theme.carvana.gray.medium};
    }
  `
};

export const NavTabIconWrapper = styled.div`
  margin-right: 18px;
`;

export const CompleteIconGreen = styled(CheckCircle)`
  & > svg {
    ${common.navIconSize};
  }

  & > svg > g {
    fill: ${props => props.theme.carvana.green.primary};
  }
`;

export const IncompleteIcon = styled(CheckCircleOutlineUnchecked)`
  & > svg {
    ${common.navIconSize};
  }
`;

export const NavTabTextWrapper = styled.div``;

export const NavTabText = styled.p`
  ${common.navTabText}
  color: ${props => props.theme.carvana.blue.dark};
  font-weight: 500;
`;

export const NavTabSubtext = styled.p`
  ${common.navTabText}
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 14px;
  margin-top: 8px;
`;

export const NavTabArrow = styled(ArrowForward)`
  margin-left: auto;

  & > svg {
    height: 14px;
    width: 10px;
  }

  & > svg > g {
    fill: ${props => props.theme.carvana.gray.medium};

    ${NavTab}.active & {
      fill: ${props => props.theme.carvana.blue.dark};
    }
  }
`;
